import request from "@/utils/request";

export function getShowcaseWorks(params) {
  return request.get("/wx/showcase/works", params, { login: false });
}

export function getShowcaseWorkDetail(id) {
  return request.get(`/wx/showcase/works/${id}`, {}, { login: false });
}

export function getShowcaseCategories() {
  return request.get("/wx/showcase/categories", {}, { login: false });
}

export function submitShowcaseWork(data) {
  return request.post("/wx/showcase/works", data, { login: true });
}
